<template>
  <div>
    <br>
    <v-expansion-panels v-model="panel" :accordion='false' :focusable='true'>
      <v-expansion-panel>
        <v-expansion-panel-header v-if="1 === 0" class="grey lighten-4 change-font" primary-title>
          <div class="spinner-grow"></div>Cargando tareas &#8230;
        </v-expansion-panel-header>
        <v-expansion-panel-header v-else primary-title>
          Mis tareas - {{ nombre }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-tabs v-model="tabbandeja" show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left"
            background-color="blue-grey lighten-4" horizontal>
            <v-tabs-slider></v-tabs-slider>
            <v-tab>
              <div v-if="RolDelegado">
                <v-icon left>edit</v-icon>Elaboración
              </div>
              <div v-else>
                <v-icon left>edit</v-icon>Revisión
              </div>

            </v-tab>
            <v-tab>
              <v-icon left>search</v-icon>Consulta
            </v-tab>
            <v-tab-item>
              <div v-if="nombre == 'Ficha técnica'">
                <label class="v-label primary--text Label-primary">
                  En esta sección encontrará los indicadores de seguimiento a la Paz para diligenciar la Ficha Técnica
                </label>
              </div>
              <v-spacer></v-spacer>
              <v-text-field v-model="buscarbandeja" append-icon="search" label="Buscar" single-line hide-details
                @keyup="filtrar"></v-text-field>
              <v-spacer></v-spacer>
              <v-data-table :headers="headerFields" :items="tareasbuscar" class="elevation-2" :no-data-text="gnodata"
                dense :items-per-page="10">
                <template v-slot:item.fechacreacion="{ item }">{{ formato(item) }}</template>
                <template v-slot:[`item.respuestaDT`]="{ item }">
                  <div v-if="item.respuestaDT == true">Aprobado</div>
                  <div v-else-if="item.respuestaDT == false">Rechazado</div>
                  <div v-else></div>
                </template>
                <template v-slot:[`item.respuestaSDHP`]="{ item }">
                  <div v-if="item.respuestaSDHP == true">Aprobado</div>
                  <div v-else-if="item.respuestaSDHP == false">Rechazado</div>
                  <div v-else></div>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <div>
                        <v-icon v-if="item.activo" small class="mr-2" :color="color(item)" @click="editItem(item)"
                          v-on="on">edit</v-icon>
                        <v-icon v-else small class="mr-2" @click="editItem(item)" v-on="on">mdi-eye</v-icon>
                      </div>
                    </template>
                    <span v-if="item.activo">Gestión de la tarea asignada</span>
                    <span v-else>Tarea gestionada</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-text-field v-model="buscarbandejaCons" append-icon="search" label="Buscar" single-line hide-details
                @keyup="filtrarCons"></v-text-field>
              <v-spacer></v-spacer>
              <v-data-table :headers="headerFields" :items="tareasbuscarCons" class="elevation-2"
                :no-data-text="gnodata" dense :items-per-page="10">
                <!-- <template v-slot:item.idflujoNavigation.entidad="{ item }">
                        <div v-if="item.interna === true">
                          <v-chip class="ma-2">{{item.idflujoNavigation.entidad}}</v-chip>
                          <v-chip class="ma-2" color="secondary">{{entidad}}</v-chip>
                        </div>
                        <div v-else>
                          <v-chip
                            class="ma-2"
                            color="secondary"
                            :ripple="false"
                          >{{item.idflujoNavigation.entidad}}</v-chip>
                          <v-chip class="ma-2" :ripple="false">{{entidad}}</v-chip>
                        </div>
                      </template> -->
                <template v-slot:item.fechacreacion="{ item }">{{ formato(item) }}</template>
                <template v-slot:[`item.respuestaDT`]="{ item }">
                  <div v-if="item.respuestaDT == true">Aprobado</div>
                  <div v-else-if="item.respuestaDT == false">Rechazado</div>
                  <div v-else></div>
                </template>
                <template v-slot:[`item.respuestaSDHP`]="{ item }">
                  <div v-if="item.respuestaSDHP == true">Aprobado</div>
                  <div v-else-if="item.respuestaSDHP == false">Rechazado</div>
                  <div v-else></div>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <div>
                        <v-icon v-if="item.activo" small class="mr-2" :color="color(item)" @click="editItem(item)"
                          v-on="on">edit</v-icon>
                        <v-icon v-else small class="mr-2" @click="editItem(item)" v-on="on">mdi-eye</v-icon>
                      </div>
                    </template>
                    <span v-if="item.activo">Gestión de la tarea asignada</span>
                    <span v-else>Tarea gestionada</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs>




        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "bandeja",
  props: {
    proceso: Number,
    nombre: String,
  },
  data() {
    return {
      tabbandeja: null,
      entidad: "",
      panel: 0,
      tareas: [],
      tareasbuscar: [],
      tareasbuscarCons: [],
      tareassinfiltro: [],
      cargando: true,
      buscarbandeja: "",
      buscarbandejaCons: "",
      headerFields: [],
      currentUser: [],
      RolDelegado: false,
      //Parametros de paginación

      timewait: 3,
      //Seccion de filtro
      filtroIndicadores: [],
      filtroAvances: [],
      filtroHitos: [],
      filtrogeneral: [],
    };
  },
  methods: {
    ...mapActions(["get_configuraciones"]),
    usuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
    editItem(item) {
      let auten = this.usuario().token.replace("Bearer ", "");
      this.$aes.setKey(auten);
      let cifra = this.$aes.encrypt(item.idelemento.toString());
      let temporal =
        Math.random().toString(36).substring(2, 6) +
        cifra +
        Math.random().toString(36).substring(2, 6);
      let encrypted = this.$aes.encrypt(temporal);
      encrypted = encrypted.replace(/\//g, "AbcYq");
      encrypted = encrypted.replace(/\+/g, "qYcbA");
      let ruta = item.ruta.replace("{0}", encrypted);
      this.$router.push(ruta);
    },
    color(item) {
      if (item.idusuarioresponsable === null) {
        return "orange";
      } else {
        return "green";
      }
    },
    ClearIndicadorHistoric() {
      // Estas lineas de codigo se utilizan para limpiar los elementos de Indicadores gestionados
      //================================================      
      let ahorafilter = new Date();
      ahorafilter.setMinutes(ahorafilter.getMinutes() - this.timewait);
      ahorafilter = new Date(ahorafilter);
      this.filtroIndicadores.forEach((element) => {
        let fechanew = new Date(element.fecha);
        if (ahorafilter > fechanew) {
          const index = this.filtroIndicadores.indexOf(element);
          this.filtroIndicadores.splice(index, 1);
        }
      });
      localStorage.setItem(
        "IndicadorFiltrado",
        JSON.stringify(this.filtroIndicadores)
      );
      //===================================================
    },
    ClearAvanceHistoric() {
      // Estas lineas de codigo se utilizan para limpiar los elementos de Indicadores gestionados
      //================================================      
      let ahorafilter = new Date();
      ahorafilter.setMinutes(ahorafilter.getMinutes() - this.timewait);
      ahorafilter = new Date(ahorafilter);
      this.filtroAvances.forEach((element) => {
        let fechanew = new Date(element.fecha);
        if (ahorafilter > fechanew) {
          const index = this.filtroAvances.indexOf(element);
          this.filtroAvances.splice(index, 1);
        }
      });
      localStorage.setItem(
        "AvanceFiltrado",
        JSON.stringify(this.filtroAvances)
      );
      //===================================================
    },
    ClearHitoHistoric() {
      // Estas lineas de codigo se utilizan para limpiar los elementos de Indicadores gestionados
      //================================================      
      let ahorafilter = new Date();
      ahorafilter.setMinutes(ahorafilter.getMinutes() - this.timewait);
      ahorafilter = new Date(ahorafilter);
      this.filtroHitos.forEach((element) => {
        let fechanew = new Date(element.fecha);
        if (ahorafilter > fechanew) {
          const index = this.filtroHitos.indexOf(element);
          this.filtroHitos.splice(index, 1);
        }
      });
      localStorage.setItem("HitoFiltrado", JSON.stringify(this.filtroHitos));
      //===================================================
    },
    limpiarfiltrogeneral() {
      let ahorafilter = new Date();
      ahorafilter.setMinutes(ahorafilter.getMinutes() - this.timewait);
      ahorafilter = new Date(ahorafilter);
      let filtroproceso = this.filtrogeneral.filter(
        (p) => p.idproceso === this.proceso
      )[0];
      if (filtroproceso !== undefined) {
        let arreglo = filtroproceso.arreglo;
        arreglo.forEach((element) => {
          let fechanew = new Date(element.fecha);
          if (ahorafilter > fechanew) {
            const index = arreglo.indexOf(element);
            arreglo.splice(index, 1);
          }
        });
        localStorage.setItem(
          "filtrogeneral",
          JSON.stringify(this.filtrogeneral)
        );
      }
    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    formatohora(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm");
      }
    },
    filtrar() {
      this.llenarTareas(this.tareas);
      if (this.buscarbandeja === "") {
        this.tareasbuscar = this.tareasbuscar;
      } else {
        this.tareasbuscar = this.tareasbuscar.filter(
          (p) =>
            p.idflujoNavigation.codigo
              .toUpperCase()
              .indexOf(this.buscarbandeja.toUpperCase()) !== -1 ||
            p.idflujoNavigation.entidad
              .toUpperCase()
              .indexOf(this.buscarbandeja.toUpperCase()) !== -1 ||
            p.idflujoNavigation.nombre
              .toUpperCase()
              .indexOf(this.buscarbandeja.toUpperCase()) !== -1 ||
            p.idflujoNavigation.nombrefiltro
              .toUpperCase()
              .indexOf(this.buscarbandeja.toUpperCase()) !== -1
        );
      }
    },
    filtrarCons() {
      this.llenarTareas(this.tareas);
      if (this.buscarbandejaCons === "") {
        this.tareasbuscarCons = this.tareasbuscarCons;
      } else {
        this.tareasbuscarCons = this.tareasbuscarCons.filter(
          (p) =>
            p.idflujoNavigation.codigo
              .toUpperCase()
              .indexOf(this.buscarbandejaCons.toUpperCase()) !== -1 ||
            p.idflujoNavigation.entidad
              .toUpperCase()
              .indexOf(this.buscarbandejaCons.toUpperCase()) !== -1 ||
            p.idflujoNavigation.nombre
              .toUpperCase()
              .indexOf(this.buscarbandejaCons.toUpperCase()) !== -1 ||
            p.idflujoNavigation.nombrefiltro
              .toUpperCase()
              .indexOf(this.buscarbandejaCons.toUpperCase()) !== -1
        );
      }
    },
    llenarTareas(Listadodetareas) {
      this.tareas = Listadodetareas;
      this.tareasbuscar = [];
      this.currentUser.forEach((element) => {
        this.tareasbuscar = Object.assign(this.tareasbuscar, this.tareas.filter((X) => X.idrolcalculado === element.idrol));
      });

      if (this.tareasbuscar.length > 0) {
        this.tareasbuscarCons = [];
        this.tareasbuscarCons = this.tareas.filter((X) => X.idrolcalculado != this.tareasbuscar[0].idrol);
      }
      else
        this.tareasbuscarCons = this.tareas;
    },
    LLenarHeaderBandeja() {
      let objproceso = this.gprocesos.filter(
        (p) => p.idproceso === this.proceso
      )[0];
      this.headerFields = [];

      this.headerFields.push({
        value: "codigo",
        text: "Código",
        sortable: true,
        width: "10%",
      });
      this.headerFields.push({
        value: "titulo1",
        text: "Nombre",
        sortable: true,
        width: "20%",
      });
      if (objproceso.verinstrumento === true) {
        this.headerFields.push({
          value: "idflujoNavigation.instrumento",
          text: "Instrumento de planeación",
          sortable: false,
          width: "10%",
        });
        this.headerFields.push({
          value: "sector",
          text: "Sector",
          sortable: true,
          width: "20%",
        });
      }
      this.headerFields.push({
        value: "idflujoNavigation.entidad",
        text: "Entidad",
        sortable: true,
        width: "20%",
      });
      this.headerFields.push({
        value: "idflujoNavigation.estado",
        text: "Estado",
        sortable: true,
        width: "10%",
      });

      if (this.tabbandeja == 0) {
        if (objproceso.verrespuesta === true) {
          if (this.RolDelegado == false) {
            this.headerFields.push({
              value: "respuestaDT",
              text: "DT",
              sortable: true,
              width: "10%",
            });
            this.headerFields.push({
              value: "respuestaSDHP",
              text: "SDHP",
              sortable: true,
              width: "10%",
            });
          }
        }
      }

      if (objproceso.verfechacorte === true) {
        this.headerFields.push({
          value: "idflujoNavigation.fechacorteproceso",
          text: objproceso.etiquetafechacorte,
          sortable: true,
          width: "10%",
        });
        if (objproceso.idproceso === 8) {
          this.headerFields.push({
            text: "Vigencia",
            value: "idflujoNavigation.vigencia",
            sortable: false,
            width: "100px",
            align: "center"
          });
        }
      }
      this.headerFields.push({
        value: "nombreresponsable",
        text: "Responsable",
        sortable: true,
        width: "12%",
      });

      if (this.tabbandeja == 0) {
        if (objproceso.verdiasfaltantes === true) {
          this.headerFields.push({
            value: "tiempoRestante",
            text: "Plazo de revisión",
            sortable: true,
            width: "15%",
          });
        }
      } else {
        this.headerFields.push({
          value: "ultimaModificacion",
          text: "Fecha último estado",
          sortable: true,
          width: "10%",
        });
      }


      this.headerFields.push({
        text: "Acción",
        value: "action",
        sortable: false,
        width: "100px",
        align: "center",
      });
      let vfiltro = localStorage.IndicadorFiltrado;
      if (vfiltro !== undefined) {
        this.filtroIndicadores = JSON.parse(unescape(vfiltro));
      }
      let Afiltro = localStorage.AvanceFiltrado;
      if (Afiltro !== undefined) {
        this.filtroAvances = JSON.parse(unescape(Afiltro));
      }
      let Hfiltro = localStorage.HitoFiltrado;
      if (Hfiltro !== undefined) {
        this.filtroHitos = JSON.parse(unescape(Hfiltro));
      }
      let sfiltrogeneral = localStorage.filtrogeneral;
      if (sfiltrogeneral !== undefined) {
        this.filtrogeneral = JSON.parse(unescape(sfiltrogeneral));
      }
      this.cargando = false;
      let indexfilter = -1;
      this.tareassinfiltro = this.gtareas.filter(
        (p) => p.idflujoNavigation.idproceso === this.proceso
      );
      if (this.tareassinfiltro.length > 0) {
        this.limpiarfiltrogeneral();
        let filtroproceso = this.filtrogeneral.filter(
          (p) => p.idproceso === this.proceso
        )[0];
        if (filtroproceso !== undefined) {
          let arreglo = filtroproceso.arreglo;
          arreglo.forEach((element) => {
            let itemfilter = this.tareassinfiltro.filter(
              (X) => X.idelemento == element.idelemento
            )[0];
            indexfilter = -1;
            indexfilter = this.tareassinfiltro.indexOf(itemfilter);
            if (indexfilter >= 0) this.tareassinfiltro.splice(indexfilter, 1);
          });
        }
        if (this.tareassinfiltro[0].idflujoNavigation.idproceso == 1) {
          this.ClearIndicadorHistoric();
          this.filtroIndicadores.forEach((element) => {
            let itemfilter = this.tareassinfiltro.filter(
              (X) => X.idelemento == element.indicador
            )[0];
            indexfilter = -1;
            indexfilter = this.tareassinfiltro.indexOf(itemfilter);
            if (indexfilter >= 0) this.tareassinfiltro.splice(indexfilter, 1);
          });
        }
        if (this.tareassinfiltro[0].idflujoNavigation.idproceso == 2) {
          this.ClearAvanceHistoric();
          this.filtroAvances.forEach((element) => {
            let itemfilter = this.tareassinfiltro.filter(
              (X) => X.idelemento == element.indicador
            )[0];
            indexfilter = -1;
            indexfilter = this.tareassinfiltro.indexOf(itemfilter);
            if (indexfilter >= 0) this.tareassinfiltro.splice(indexfilter, 1);
          });
        }
        if (this.tareassinfiltro[0].idflujoNavigation.idproceso == 4) {
          this.ClearHitoHistoric();
          this.filtroHitos.forEach((element) => {
            let itemfilter = this.tareassinfiltro.filter(
              (X) => X.idelemento == element.idhito
            )[0];
            indexfilter = -1;
            indexfilter = this.tareassinfiltro.indexOf(itemfilter);
            if (indexfilter >= 0) this.tareassinfiltro.splice(indexfilter, 1);
          });
        }
        if (this.tareassinfiltro[0].idflujoNavigation.idproceso == 10) {
          this.ClearHitoHistoric();
          this.filtroIndicadores.forEach((element) => {
            let itemfilter = this.tareassinfiltro.filter(
              (X) => X.idelemento == element.indicador
            )[0];
            indexfilter = -1;
            indexfilter = this.tareassinfiltro.indexOf(itemfilter);
            if (indexfilter >= 0) this.tareassinfiltro.splice(indexfilter, 1);
          });
        }
      }
      this.llenarTareas(this.tareassinfiltro);
    }
  },
  created() {
    this.currentUser = this.usuario().usuarioRol;
    this.currentUser.forEach((element) => {
      if (element.nombreRol == 'Delegado') {
        this.RolDelegado = true;
      }
    });
    this.get_configuraciones();
  },
  computed: {
    ...mapGetters(["gtareas", "gconfiguraciones", "gprocesos"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    itemsporpagina() {
      if (!isNaN(this.itemsPerPageSopCuan)) return this.itemsPerPageSopCuan;
      else return 1;
    },
  },
  mounted() {
    this.LLenarHeaderBandeja()
  },
  watch: {
    gtareas: function () {
      this.cargando = false;
      let indexfilter = -1;
      this.tareassinfiltro = this.gtareas.filter(
        (p) => p.idflujoNavigation.idproceso === this.proceso
      );
      if (this.tareassinfiltro.length > 0) {
        this.limpiarfiltrogeneral();
        let filtroproceso = this.filtrogeneral.filter(
          (p) => p.idproceso === this.proceso
        )[0];
        if (filtroproceso !== undefined) {
          let arreglo = filtroproceso.arreglo;
          arreglo.forEach((element) => {
            let itemfilter = this.tareassinfiltro.filter(
              (X) => X.idelemento == element.idelemento
            )[0];
            indexfilter = -1;
            indexfilter = this.tareassinfiltro.indexOf(itemfilter);
            if (indexfilter >= 0) this.tareassinfiltro.splice(indexfilter, 1);
          });
        }
        if (this.tareassinfiltro[0].idflujoNavigation.idproceso == 1) {
          this.ClearIndicadorHistoric();
          this.filtroIndicadores.forEach((element) => {
            let itemfilter = this.tareassinfiltro.filter(
              (X) => X.idelemento == element.indicador
            )[0];
            indexfilter = -1;
            indexfilter = this.tareassinfiltro.indexOf(itemfilter);
            if (indexfilter >= 0) this.tareassinfiltro.splice(indexfilter, 1);
          });
        }
        if (this.tareassinfiltro[0].idflujoNavigation.idproceso == 2) {
          this.ClearAvanceHistoric();
          this.filtroAvances.forEach((element) => {
            let itemfilter = this.tareassinfiltro.filter(
              (X) => X.idelemento == element.indicador
            )[0];
            indexfilter = -1;
            indexfilter = this.tareassinfiltro.indexOf(itemfilter);
            if (indexfilter >= 0) this.tareassinfiltro.splice(indexfilter, 1);
          });
        }
        if (this.tareassinfiltro[0].idflujoNavigation.idproceso == 4) {
          this.ClearHitoHistoric();
          this.filtroHitos.forEach((element) => {
            let itemfilter = this.tareassinfiltro.filter(
              (X) => X.idelemento == element.idhito
            )[0];
            indexfilter = -1;
            indexfilter = this.tareassinfiltro.indexOf(itemfilter);
            if (indexfilter >= 0) this.tareassinfiltro.splice(indexfilter, 1);
          });
        }
        if (this.tareassinfiltro[0].idflujoNavigation.idproceso == 10) {
          this.ClearHitoHistoric();
          this.filtroIndicadores.forEach((element) => {
            let itemfilter = this.tareassinfiltro.filter(
              (X) => X.idelemento == element.indicador
            )[0];
            indexfilter = -1;
            indexfilter = this.tareassinfiltro.indexOf(itemfilter);
            if (indexfilter >= 0) this.tareassinfiltro.splice(indexfilter, 1);
          });
        }
      }
      this.llenarTareas(this.tareassinfiltro);
    },
    gconfiguraciones() {
      let GetConfigtime = this.gconfiguraciones.filter(
        (X) => X.codigo == "TiempoEspera"
      )[0];
      if (GetConfigtime != undefined) {
        this.timewait = GetConfigtime.valor;
      }
      this.entidad = this.gconfiguraciones.filter(
        (p) => p.codigo == "EntidadRevision"
      )[0].valor;
    },
    tabbandeja: function () {
      this.LLenarHeaderBandeja()
    }
  },
};
</script>